import React from "react";
import PhoneInput from "react-phone-number-input";
import { InputField, InputFieldProps } from "./InputField";
import { E164Number } from "../../../../api/src/types";

export interface PhoneInputFieldProps {
  value: string;
  handlePhoneChange: (value: E164Number | undefined) => void;
  placeholder?: string;
  errorMessage?: string | null;
  required?: boolean;
  className?: string;
  inputComponent?: React.ComponentType<InputFieldProps>;
}

const PhoneInputField: React.FC<PhoneInputFieldProps> = ({
  value,
  handlePhoneChange,
  placeholder = "Enter phone number",
  errorMessage,
  required = false,
  className = "phone-input",
}) => {
  return (
    <div className={className} data-ls-disabled>
      <PhoneInput
        withCountryCallingCode={true}
        defaultCountry="US"
        internationalMode="international"
        onChange={handlePhoneChange}
        value={value}
        inputComponent={InputField}
        placeholder={placeholder}
        errorMessage={errorMessage ?? undefined}
        required={required}
        data-testid="phone-input"
      />
    </div>
  );
};

export default PhoneInputField;
